import React from 'react';

const EmptySearch = (props) => {
  return <div>no hay resultados para: {props.searchValue}</div>;
};
export {EmptySearch};

